<template>
<div class="page search-page">
  <div class="head">
      <div class="search-wrap">
          <i class="search-icon" type="search" size="25"></i>
          <input type="search" @focus="focusSearch" v-model="productName" class="search-input" placeholder="请输入商品名称" />
      </div>
      <div class="search-btn-wrap">
          <span @click="search">搜索</span>
      </div>
  </div>
  <div v-if="searchMode == 'search'">
      <div class="content">
          <div class="search-card-item">
              <div class="search-card-title">
                  <span class="title">历史记录</span>
                  <img class="del" @click="delHistory" src="../assets/images/icon/del.png" />
              </div>
              <div class="item-content">
                  <span v-for="(item, key) in historyArr" @click="searchProduct(item)" class="keyword-btn" :key="key">{{item}}</span>
              </div>
          </div>
      </div>
  </div>
  <div v-if="searchMode == 'goodlist'" class="scroll-view" v-scroll-bottom="loadMoreData">
      <div class="content">
          <good-list :isSearch="false" :product-list="productList" :has-more="hasMore"></good-list>
      </div>
  </div>
</div>
</template>
<script>
import GoodList from '@/components/list/GoodList.vue'
import productHelper from '@/helpers/productHelper'
export default {
  components: {
    GoodList
  },
  data() {
    return {
      historyArr: [],
      productName: '',
      productList: [],
      hasMore: false,
      searchMode: 'search',
      showToast: false,
      searchClient: 'h5'
    }
  },
  created() {
    this.historyArr = localStorage.getItem('history') ? JSON.parse(localStorage.getItem('history')) : []

  },
  mounted() {

  },
  methods: {
    focusSearch() {
        this.searchMode = 'search'
    },
    search() {
        if (this.historyArr[this.historyArr.length - 1] == this.productName || this.productName == '') return
        this.historyArr.push(this.productName)
        // 添加到storage
        localStorage.setItem('history', JSON.stringify(this.historyArr))

        this.searchProduct(this.productName)
    },
    searchProduct( item ) {
        
        this.productName = item
        
        this.searchMode = 'goodlist'

        this.page = 1
        this.productList = []
        productHelper.getProductList(this)
    },
    delHistory() {
        console.log('delHistory')
        this.historyArr = []
        localStorage.setItem('history',JSON.stringify([]))
    },
    loadMoreData() {
      this.page++
      productHelper.getProductList(this)
    }
  }
}
</script>
<style scoped>
.page {
    background-color: rgba(0, 0, 0, 0.05);
}
.search-page{
    padding: var(--len10);
    min-height: 100vh;
}
.head {
    display: flex;
    align-items: center;
    margin-top: var(--len10);
}

.search-wrap {
    flex: 1;
    padding-bottom: var(--len10);
}

.search-input {
    width: 100%;
    height: var(--len30);
    background-color: white;
    border-radius: var(--len30);
    box-sizing: border-box;
    padding-left: var(--len35);
    font-size: var(--len12);
    /* margin-right: 20px; */
}

.search-icon {
    position: absolute;
    top: var(--len3);
    left: var(--len10);
    color: lightgray;
}

.search-btn-wrap {
    margin-left: var(--len10);
    font-size: var(--len14);
    font-weight: normal;
    color: black;
}

.content {
    margin-top: var(--len10);
}

.search-card-item {
    margin-top: var(--len10);
}

.search-card-title {
    display: flex;
    /* margin-left: 10px; */
    align-items: center;
}

.search-card-title .title {
    font-size: var(--len14);
    font-weight: bold;
    flex: 1;
}

.search-card-title .del {
    font-size: var(--len12);
    width: var(--len14);
    height: var(--len14);
    line-height: var(--len14);

}

.item-content {
    /* padding: 0 10px; */
}

.keyword-btn {
    margin-right: var(--len10);
    margin-top: var(--len10);
    background-color: rgba(0, 0, 0, 0.1);
    padding: var(--len5) var(--len10) var(--len5) var(--len10);
    font-size: var(--len12);
    font-weight: normal;
    border-radius: var(--len14);
    display: inline-block;
}
</style>